<div class="search-modal-favorites-slide d-flex flex-column">
  <app-search-modal-favorites-navbar-top
    [title]="searchParams.locationName"
  ></app-search-modal-favorites-navbar-top>

  <div
    [appBackgroundUrl]="backgroundImage"
    class="w-100 h-100 d-flex flex-column"
  >
    <div class="position-absolute-0 backdrop-filter-brightness-0-35"></div>

    <div class="position-absolute-0 font-size-1rem d-flex flex-column overflow-y">
      <div class="text-white w-100 d-flex justify-content-center mt-2rem">Getting together takes a lot of time & effort</div>

      <div class="text-white w-100 d-flex justify-content-center">for friends who aren't neighbors</div>

      <div class="text-white w-100 d-flex justify-content-center mt-3">Neighbors who are friends hang out easily</div>

      <div class="text-white w-100 d-flex justify-content-center mt-3">Get matched by interests & life stage to unlock </div>

      <div class="text-white w-100 d-flex justify-content-center">friendship with neighbors</div>

      <div class="w-100 d-flex justify-content-center">
        <div class="icon-v2 mmmm-logo-gold scale-6 mt-6-7rem"></div>
      </div>

      <div class="text-white w-100 d-flex justify-content-center mt-6-7rem">Midweek • Dinner • Dessert • Drinks</div>

      <div class="d-flex justify-content-center mt-2-5rem mb-5-5rem">
        <button
          class="btn rounded-pill btn-gold btn-block text-transform-none w-45"
          (click)="openMembershipModal()"
        >
          Join a party of 4
        </button>
      </div>
    </div>
  </div>
</div>
